import React, { useEffect, useState } from 'react';

import {
	Loader,
	LoadingView
} from '../../components/common/loader';

import {
	DeliverSuccessfull,
	DeliveryErrorMessages,
	MissedDeliveryErrorMessages,
	PickedUpSuccessfully
} from '../../components/common/AllConfirmationMessages';

import { PatientDetails, VideoCallButton } from '../../components/common/patientDetails';

import {
	apiKey,
	deliveryDriverDeliveredDispense
} from '../../networking/urlEndPoints';

import { useLocation } from 'react-router-dom';
import { ErrorMessages } from '../../components/error/errorMessages';
import { useAllSelector } from '../../services/selectors/allSelector';

import { fetchTodayMissed } from '../../services/apis/dispense/todayMissed';
import { updateDeliveryStatus } from '../../services/apis/dispense/updateDeliveryStatus';
import { MissedDeliveryConfirmation } from '../../components/common/routeConfirmation';

import { useCustomStates } from '../../hooks/useCustomStates';
import { DispenseRxData } from '../../components/common/dispenseRxData';
import DriverAppointmentCallPanel from '../../components/common/driverAppointmentCallPanel';
import { handleToggleRXData, refreshCurrentLocation } from '../../utils/helper/helper'
import { openDeliveryPatientOnSignPage } from '../../utils/constants/deliveryPrivacy';

import { useAuthSelector } from '../../services/selectors/authSelector';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
import { clearConfirmDeliveryUserMessage } from '../../services/slices/dispense/confirmDelivery';
import { clearUpdateDeliveryUserMessage } from '../../services/slices/dispense/updateDeliveryStatus';
import { TodayMissedDeliveredByAnotherDriverAblyHelper } from '../../utils/helper/ablyDeliveredDispenseByOthers';
import { getFlexiDeliveryPatientIds, handleMissedConfirmDelivery } from '../../utils/helper/deliveriesHelper';
import { buildDeliverRxIdsPayload } from '../../utils/helper/deliveredRxDisplay';

import SearchBox from '../../components/common/searchBox';

import * as Common from '../../components/common';
import * as Hooks from '../../hooks';

const TodaysMissedDelivery = () => {

	const dispatch = Hooks.useCustomDispatch();
	const navigate = Hooks.useCustomNavigate();
	const location = useLocation()

	const { pharmacyId, pharmacyInspectionMode, driverID } = useAuthSelector()
	const { confirmDeliveryResponse, todayMissedListResponse, validateReturnedPatchesResponse, todayMissedList, pharmacist_assistant_status, updateDeliveryListResponse } = useAllSelector();

	const {
		comment,
		setComment,

		cordinate,
		setCordinate,

		openIndex,
		setOpenIndex,

		patientSignature,
		setPatientSignature,

		pharmacistSignature,
		setPharmacistSignature,

		showErrorToast,
		setShowErrorToast,

		showSuccessToast,
		setShowSuccessToast,

		showComment,
		setShowComment,

		showPatientSignature,
		setShowPatientSignature,

		showData,
		setShowData,

		showToast,
		setShowToast,

		showPharmacistSignature,
		setShowPharmacistSignature,

		missedDeliveryConfirmation,
		setMissedDeliveryConfirmation,

		missedData,
		setMissedData,

		missedExplanation,
		setMissedExplanation,

		missedExplanationError,
		setMissedExplanationError,

		missedDeliverErrorToast,
		setMissedDeliveryErrorToast,

		isRefused,
		setIsRefused,

		signatureErrors,
		setSignatureErrors,

		covid19,
		setCovid19,

		loading,
		setLoading,

		isTransferRequest,
		setIsTransferRequest,

		setPId,

		consultation,
		setConsultation,

		newRxCounsellingValues,
		setNewRxCounsellingValues,

		isPatientVerified,
		setIsPatientVerified,

		selectedDoses,
		setSelectedDoses,
		unconsumedDoseEntries,
		setUnconsumedDoseEntries,
		unconsumedDoseErrors,
		setUnconsumedDoseErrors

	} = useCustomStates()

	const [flexiProofImages, setFlexiProofImages] = useState({})
	const [copayPaymentOptions, setCopayPaymentOptions] = useState({})
	const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([])
	const [deliveryTab, setDeliveryTab] = useState('your')
	const { getMatchedAppointmentDelivery } = Hooks.useTodayAppointmentDeliveryMap({
		pharmacyId,
		enabled: Boolean(
			pharmacyId &&
			deliveryTab !== 'others' &&
			!todayMissedListResponse?.loading &&
			Array.isArray(todayMissedList) &&
			todayMissedList.length > 0
		),
		refreshKey: `today-missed:${deliveryTab}`,
	})

	const handleDropdownToggle = (index, data) => {
		if (openDeliveryPatientOnSignPage(navigate, data)) {
			return;
		}

		setConsultation(null)
		setNewRxCounsellingValues([])
		setSelectedDoses({})
		if (openIndex !== index) {
			refreshCurrentLocation(setCordinate)
			const rxIds = data?.patients_win_rx_data_today_missed?.map((r) => r.id).filter(Boolean) || []
			setSelectedDeliverRxIds(rxIds)
		}
		handleToggleRXData(
			index,
			data,
			openIndex,
			setOpenIndex,
			dispatch,
			setSignatureErrors,
			setShowData,
			RemoveAllPatchesId,
			setPatientSignature,
			setShowComment,
			setShowPatientSignature,
			setShowPharmacistSignature,
			setPharmacistSignature,
			setComment,
			setIsPatientVerified,
			setUnconsumedDoseEntries,
			setUnconsumedDoseErrors,
			setMissedExplanation,
			setMissedExplanationError,
			setPId,
			pharmacyId
		);
	};

	useEffect(() => {
		if (!pharmacyId) return;
		const abortController = new AbortController();
		const params = {
			pharmacy_id: pharmacyId,
			status: 'today_missed',
			tab: deliveryTab,
			signal: abortController.signal,
		};
		dispatch(fetchTodayMissed(params));
		return () => {
			abortController.abort();
		};
	}, [deliveryTab, dispatch, pharmacyId]);

	const refreshTodayMissed = () => {
		if (!pharmacyId || todayMissedListResponse?.loading) return;
		setOpenIndex(null);
		dispatch(fetchTodayMissed({ pharmacy_id: pharmacyId, status: 'today_missed', tab: deliveryTab }));
	};

	useEffect(() => {
		setOpenIndex(null)
		setShowData(false)
		setMissedData(null)
		setMissedDeliveryConfirmation(false)
		setSelectedDeliverRxIds([])
		setSelectedDoses({})
		setConsultation(null)
		setNewRxCounsellingValues([])
		setComment('')
		setPatientSignature([null])
		setPharmacistSignature(null)
		setIsPatientVerified(false)
		setUnconsumedDoseEntries({})
		setUnconsumedDoseErrors({})
		setMissedExplanation('')
		setMissedExplanationError('')
	}, [deliveryTab, setComment, setConsultation, setIsPatientVerified, setMissedData, setMissedDeliveryConfirmation, setMissedExplanation, setMissedExplanationError, setNewRxCounsellingValues, setOpenIndex, setPatientSignature, setPharmacistSignature, setSelectedDoses, setShowData, setUnconsumedDoseEntries, setUnconsumedDoseErrors])

	const handleConfirmDelivery = (patientData) => {
		let filteredData = patientData?.patients_win_rx_data_today_missed?.filter(item => item.is_din_matched.is_fentanyl === 1);
		const hasRxWitness = patientData?.patients_win_rx_data_today_missed?.some(patient => patient.rx_witness === "Y");

		handleMissedConfirmDelivery({
			patientData,
			pharmacyId: pharmacyId,
			selectedPharmacistID: null,
			patientSignature: patientSignature,
			pharmacistSignature: pharmacistSignature,
			cordinate: cordinate,
			comment: comment,
			dispatch,
			setOpenIndex: setOpenIndex,
			setShowErrorToast: setShowErrorToast,
			setShowSuccessToast: setShowSuccessToast,
			isRefused: isRefused,
			covid19: covid19,
			validateReturnedPatchesResponse: validateReturnedPatchesResponse,
			isTransferRequest: isTransferRequest,
			setIsTransferRequest: setIsTransferRequest,
			pharmacyInspectionMode: pharmacyInspectionMode,
			setSignatureErrors: setSignatureErrors,
			setIsRefused: setIsRefused,

			fetchAction: 'today_missed',
			filteredData: filteredData,
			hasRxWitness: hasRxWitness,
			pharmacist_assistant_status: pharmacist_assistant_status,
			consultation: consultation,
			new_rx_counselling_values: newRxCounsellingValues,
			selectedDoses: selectedDoses,
			flexiProofImages: flexiProofImages,
			copayPaymentOptions: copayPaymentOptions,
			isPatientVerified,
			selectedDeliverRxIds: selectedDeliverRxIds,
			unconsumedDoseEntries,
			setUnconsumedDoseErrors,
			tab: deliveryTab,
		});
	};

	const handleMissedDelivery = (patient_id) => {
		const trimmedExplanation = missedExplanation?.trim();
		if (!trimmedExplanation) {
			setMissedExplanationError('Explanation is required.');
			return;
		}

		setMissedExplanationError('');

		// const isDilaudidID = missedData?.patients_win_rx_data_today_missed
		// 	?.map((value) => value?.investigate_dilaudid_today_missed)
		// 	.filter(id => id !== null).flat()
		const flexiDeliveryIDs = getFlexiDeliveryPatientIds(missedData?.patients_win_rx_data_today_missed);
		const params = {
			pharmacy_id: pharmacyId,
			route: patient_id.route,
			tab: deliveryTab,
		}

		const requesteData = {
			pharmacy_id: pharmacyId,
			dispatch: dispatch,
			params: params,
			patient_id: missedData.id,
			setOpenIndex: setOpenIndex,
			setMissedDeliveryErrorToast: setMissedDeliveryErrorToast,
			setMissedDeliveryConfirmation: setMissedDeliveryConfirmation,
			type: 'today_missed',
			// frequency_dose_id: isDilaudidID[0]?.id
			// frequency_dose_id: selectedDoses?.map(dose => dose?.dose_id),
			frequency_dose_id: Object?.values(selectedDoses)?.flat()?.map(dose => dose.dose_id),
			missed_explanation: trimmedExplanation,
			flexi_rx_refill_id: flexiDeliveryIDs,
			tab: deliveryTab,
			...buildDeliverRxIdsPayload(selectedDeliverRxIds, missedData?.patients_win_rx_data_today_missed)
		}

		try {
			if (missedData && pharmacyId) {
				setMissedExplanation('');
				dispatch(updateDeliveryStatus(requesteData))
			}
		}
		catch {

		}
	}

	return (
		<>
			<div className="app-wrapper flex justify-center">
				<div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden ">
					<div className="relative p-4">
						<Common.TopBar />

						<div className="flex gap-3 mb-3">
							<SearchBox pharmacyId={pharmacyId} onRefresh={refreshTodayMissed} isRefreshing={todayMissedListResponse?.loading} />
						</div>


						<div className="title-row my-2" >
							<h1 className="text-xl font-bold">Today Missed Dispense</h1>
						</div>

						<Common.YourOthersTabs
							value={deliveryTab}
							onChange={setDeliveryTab}
							includeTransferred={false}
						/>

						<div className="routes-list">
							{todayMissedListResponse?.loading ?

								<div className='flex justify-center pb-4 h-96'>
									<LoadingView />
								</div> :

								todayMissedListResponse?.error !== null ?

									<div className='flex items-center justify-center pb-4 mb-4  h-96'>
										<ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
									</div> :

									todayMissedList?.length === 0 ?
										<p className='flex justify-center pb-4 pt-3  h-96'>
											{`No missed deliveries in ${deliveryTab === 'your' ? 'Your' : 'Others'}.`}
										</p>
										:

										todayMissedList?.map((data, index) => {
											const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
											const isRouteAllowed = data.route_access?.allowed !== false;
											const appointmentDelivery = deliveryTab !== 'others' && isRouteAllowed ? getMatchedAppointmentDelivery(data) : null;
											return (
											<React.Fragment key={index}>

												<div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
													<PatientDetails
														data={data}
														patientImg={data.profile_image}
														totalRxData={data?.patients_win_rx_data_today_missed?.length}
														index={index}
														openIndex={openIndex}
														onDropdownToggle={handleDropdownToggle}
														hideVideoCallButton={deliveryTab === 'others'}
													>
													<>
															<DispenseRxData
																rxData={data?.patients_win_rx_data_today_missed}
																patientData={data}
																newRxCounsellingValues={newRxCounsellingValues}
																setNewRxCounsellingValues={setNewRxCounsellingValues}
																selectedDoses={selectedDoses}
																setSelectedDoses={setSelectedDoses}
																type="new_rx"
																flexiProofImages={flexiProofImages}
																setFlexiProofImages={setFlexiProofImages}
																copayPaymentOptions={copayPaymentOptions}
																setCopayPaymentOptions={setCopayPaymentOptions}
																selectedDeliverRxIds={selectedDeliverRxIds}
																setSelectedDeliverRxIds={setSelectedDeliverRxIds}
																unconsumedDoseEntries={unconsumedDoseEntries}
																setUnconsumedDoseEntries={setUnconsumedDoseEntries}
																unconsumedDoseErrors={unconsumedDoseErrors}
																setUnconsumedDoseErrors={setUnconsumedDoseErrors}
																isActiveDeliverRxCard={openIndex === index} />

															{showData &&
																<React.Fragment>
																	<Common.Comment setComment={setComment}
																		comment={comment}
																		showComment={showComment}
																		setShowComment={setShowComment} />

																	<Common.DeliveryConsultationDropdown consultation={consultation}
																		setConsultation={setConsultation} />

																	<Common.PatientSignature patientSignature={patientSignature}
																		setPatientSignature={setPatientSignature}
																		showPatientSignature={showPatientSignature}
																		setShowPatientSignature={setShowPatientSignature}
																		isRefused={isRefused}
																		setIsRefused={setIsRefused}
																		isPatientVerified={isPatientVerified}
																		setIsPatientVerified={setIsPatientVerified}
																		signatureErrors={signatureErrors}
																		setSignatureErrors={setSignatureErrors}
																		covid19={covid19}
																		setCovid19={setCovid19}
																		rxData={data?.patients_win_rx_data_today_missed}
																	/>

																	{pharmacist_assistant_status === 1 ? null :
																		<Common.PharmacistSignature
																			pharmacistSignature={pharmacistSignature}
																			setPharmacistSignature={setPharmacistSignature}
																			showPharmacistSignature={showPharmacistSignature}
																			setShowPharmacistSignature={setShowPharmacistSignature}
																			signatureErrors={signatureErrors}
																			setSignatureErrors={setSignatureErrors}
																		/>}



																</React.Fragment>
															}

															{!isRouteAllowed && (
																<div className="mb-2 px-2 py-1 rounded text-xs font-medium bg-yellow-100 text-yellow-700">
																	This patient is not on your active route
																</div>
															)}
															<div className="flex items-center gap-2">
																<VideoCallButton
																	data={data}
																	variant="cta"
																	disabled={noRxSelected || !isRouteAllowed}
																	label="Video call"
																/>

																{!showData &&
																	<button
																		className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-red-500 text-white'}`}
																		disabled={noRxSelected || !isRouteAllowed}
																		onClick={() => {
																			if (noRxSelected || !isRouteAllowed) return;
																			setMissedData(data);
																			setMissedExplanation('');
																			setMissedExplanationError('');
																			setMissedDeliveryConfirmation(true);
																		}}>
																		Missed
																	</button>}

																{showData ?
																	
																		<button
																			className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																			disabled={noRxSelected || !isRouteAllowed}
																			onClick={() => {
																				if (noRxSelected || !isRouteAllowed) return;
																				handleConfirmDelivery(data);
																			}}>
																			{confirmDeliveryResponse?.loading ? <p className='flex justify-center items-center'><Loader /></p> : '  Continue'}
																		</button>
																	:
																	<button
																		className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																		disabled={noRxSelected || !isRouteAllowed}
																		onClick={() => {
																			if (noRxSelected || !isRouteAllowed) return;
																			setShowData(true);
																			setTimeout(() => {
																				const windowHeight = window.innerHeight;
																				const scrollAmount = windowHeight / 2;
																				window.scrollBy({ top: scrollAmount, behavior: "smooth" });
																			}, 100);
																		}}>
																		Deliver
																	</button>
																}
															</div>
													</>
													</PatientDetails>
													{appointmentDelivery ? (
														<DriverAppointmentCallPanel
															patient={data}
															appointmentDelivery={appointmentDelivery}
														/>
													) : null}
												</div>
											</React.Fragment>);
										})}
						</div>
					</div>

					{showToast && <PickedUpSuccessfully setShowToast={setShowToast} />}
					{showErrorToast && (
						<DeliveryErrorMessages
							setShowErrorToast={setShowErrorToast}
							message={confirmDeliveryResponse?.userFacingErrorMessage}
							onDismiss={() => dispatch(clearConfirmDeliveryUserMessage())}
						/>
					)}
					{showSuccessToast && <DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}
					{missedDeliverErrorToast && (
						<MissedDeliveryErrorMessages
							setMissedDeliveryErrorToast={setMissedDeliveryErrorToast}
							message={updateDeliveryListResponse?.userFacingErrorMessage}
							onDismiss={() => dispatch(clearUpdateDeliveryUserMessage())}
						/>
					)}

				</div>
			</div>

			{missedDeliveryConfirmation &&
				<MissedDeliveryConfirmation setShowConfirmationModal={setMissedDeliveryConfirmation}
					showConfirmationModal={missedDeliveryConfirmation}
					pharmacyId={pharmacyId}
					handleMissedDelivery={handleMissedDelivery}
					missedData={missedData}
					missedExplanation={missedExplanation}
					setMissedExplanation={setMissedExplanation}
					missedExplanationError={missedExplanationError}
					setMissedExplanationError={setMissedExplanationError}
					isSubmitting={updateDeliveryListResponse?.loading}
				/>}

			<TodayMissedDeliveredByAnotherDriverAblyHelper
				apiKey={apiKey}
				deliveryDriverDeliveredDispense={deliveryDriverDeliveredDispense}
				pharmacyId={pharmacyId}
				dispatch={dispatch}
				setCordinate={setCordinate}
				location={location}
				setLoading={setLoading}
				driverID={driverID}
				tab={deliveryTab}
			/>

		</>
	)
}

export default TodaysMissedDelivery
